import React from 'react'
import { translate } from 'react-i18next'
import { scroller } from 'react-scroll'
import { Sticky } from 'react-stickup-ay'
import styled from 'styled-components'
import { complementaryColor } from 'uiComponents/constants/colors'

import assetArrowDown from 'assets/icons/svgs/arrow-down.svg'
interface IProps {
  toSection: string
  t?: (key: string) => string
}

class ScrollToButtonImpl extends React.PureComponent<IProps> {
  handleOnClick = section => {
    scroller.scrollTo(section, {
      smooth: true,
    })
  }

  render() {
    const { t } = this.props

    return (
      <ToAllBrands onClick={() => this.handleOnClick(this.props.toSection)}>
        {t('Zu allen Marken')}
      </ToAllBrands>
    )
  }
}

const ScrollToButton = translate()(ScrollToButtonImpl)

const StickyScrollToButton = ({ toSection, container }) => {
  return (
    <StyledSticky defaultOffsetTop={60} container={container}>
      <ScrollToButton toSection={toSection} />
    </StyledSticky>
  )
}

const ToAllBrands = styled.div`
  background: ${complementaryColor};
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  line-height: 40px;
  padding: 0 20px 0 10px;
  white-space: nowrap;
  float: right;
  margin-right: 20px;

  &::after {
    background-image: url(${assetArrowDown});
    background-position: center;
    background-repeat: no-repeat;
    content: '';
    display: inline-block;
    height: 10px;
    width: 10px;
    margin: auto -10px auto 10px;
  }
`

const StyledSticky = styled(Sticky)`
  z-index: 1;
`

export default StickyScrollToButton
